/**
 * Resolves the correct macro extension key.
 *
 * Handles the migration from Connect questionslist-macro to native
 * questionslist-macro-native by remapping the legacy key to the native one.
 */
export const resolveQuestionsMacroExtensionKey = (extensionKey: string): string => {
	if (extensionKey === 'questionslist-macro') {
		return 'questionslist-macro-native';
	}
	return extensionKey;
};

/**
 * Determines which macros should appear in the Quick Insert menu (/macro commands).
 *
 * Note: This does NOT remove manifests entirely - both manifests still exist for lookups.
 * This only controls what appears in the Quick Insert UI.
 *
 * The Connect questionslist-macro is hidden from Quick Insert in favour of the
 * native questionslist-macro-native (existing Connect macros in documents still
 * render via handler hijacking in resolveQuestionsMacroExtensionKey).
 */
export const shouldIncludeMacroInQuickInsert = (macroKey: string): boolean => {
	if (macroKey === 'questionslist-macro') {
		return false;
	}

	return true;
};
